<ng-container *ngIf="steps$ | async as steps">
  <ng-container *ngIf="btnsState$ | async as btnsState">
    <div
      class="grid grid-rows-1 md:-mx-30px"
      [ngClass]="{
			'grid-cols-2': steps.length === 2,
			'grid-cols-3': steps.length === 3,
			'grid-cols-4': steps.length === 4,
			'grid-cols-5': steps.length === 5,
		}"
    >
      <div
        *ngFor="let step of steps"
        class="item-wrap flex justify-center items-center"
        matTooltipPosition="above"
        [matTooltipShowDelay]="300"
        [ngClass]="{
          'is-active': step.type === btnsState?.v.activeStep,
          'is-first': step.index === 0,
          'is-last': step.index === steps.length - 1,
          'is-passed': step.isPassed,
          'is-visited': step.isVisited,
          'opacity-60': !step.isPassed && !step.isVisited,
          'is-invalid': btnsState?.v.invalidSteps.includes(step.type)
        }"
        matTooltip="{{ step.title | transloco }}"
      >
        <button
          type="button"
          [disabled]="!step.isVisited || step.type === btnsState?.v.activeStep"
          class="flex justify-start items-center flex-col flex-grow-1"
          (click)="setStep(step)"
        >
          <div
            class="icon-container relative w-full flex justify-center items-center"
          >
            <div
              class="z-1 icon-wrap w-45px h-45px md:w-50px md:h-50px rounded-full border border-disabled bg-white text-secondary flex justify-center items-center"
            >
              <div
                *ngIf="
                  btnsState?.v.invalidSteps.includes(step.type) &&
                    step.isVisited &&
                    step.type !== btnsState?.v.activeStep;
                  else iconTmpl
                "
                class="flex min-w-22px min-h-22px w-22px h-22px text-16px justify-center items-center text-white rounded-full"
              >
                <i class="material-icons text-20px text-error!">warning</i>
              </div>
              <ng-template #iconTmpl>
                <i
                  class="material-icons text-disabled text-18px md:text-22px"
                  >{{ step.icon }}</i
                >
              </ng-template>
            </div>
          </div>
        </button>
      </div>
    </div>

    <div class="flex justify-center items-center mt-24px relative">
      <span class="text-primary">
        <ng-container *ngIf="!isCompanyAccount">
          {{ btnsState?.v.activeStepObj.title | transloco }}
        </ng-container>
        <ng-container *ngIf="isCompanyAccount">
          {{ btnsState?.v.activeStepObj.titleCompany | transloco }}
        </ng-container>
      </span>
      &nbsp;
      <div class="absolute right-0 top-0">
        <span class="text-primary">{{
          btnsState?.v.activeStepObj.index + 1
        }}</span>
        <span class="opacity-60">&nbsp;/&nbsp;{{ steps.length }}</span>
      </div>
    </div>
  </ng-container>
</ng-container>
